import animateSpinningOfTheOnlyOneCard from "./animateSpinningOfTheOnlyOneCard";

const checkCardVerticalPositionBeforeAnimating = (element: any, options: any, isSpinningOnlyOne: boolean, verticalCardIndexOfSelectedRow: any) => {
    let verticalIndexOfTheCard = verticalCardIndexOfSelectedRow.current;
    let extremeValue = 0;

    if(verticalIndexOfTheCard === 4 || verticalIndexOfTheCard === 3 || verticalIndexOfTheCard === 2 )
    extremeValue = 0;

    if(verticalIndexOfTheCard === 1 || verticalIndexOfTheCard === 0) 
    extremeValue = 4;

    animateSpinningOfTheOnlyOneCard(element, options, extremeValue, isSpinningOnlyOne, verticalCardIndexOfSelectedRow);
}

export default checkCardVerticalPositionBeforeAnimating;